import { ContentsContainer } from 'modules/Contents'
import React from 'react'

type Props = {}

const Contents = (props: Props) => {
  return (
    <ContentsContainer />
  )
}

export default Contents;